var poll_default = {
  "fontElementMap": "pOomL",
  "container": "_0Ci-l",
  "fullscreen": "cjseY",
  "background_overlay": "FhvkU",
  "with_image": "SMlCT",
  "options": "dKKDE",
  "webview": "jqYNE",
  "grid": "xYYEp",
  "option": "p1LML",
  "cta_button": "VJRR0",
  "add_option": "nFSep",
  "see_more": "h7CC1",
  "list": "fh-eD",
  "column": "azffL",
  "additional_note": "frH1K",
  "spinner": "_2WOZH",
  "spin": "fcxkk",
  "shown": "_0D3Nr",
  "error": "MAi5H"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
